(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-cyber-body"] && !Shopify.designMode) return;
  try {
    (function () {
    function trackEvent(name, data) {
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, data);
    }
    function initRoot(root) {
      if (root.dataset.khcInit) return;
      root.dataset.khcInit = '1';

      // Mega menu toggle (desktop custom)
      var megaBtn = root.querySelector('[data-khc-mega-toggle]');
      var mega = root.querySelector('[data-khc-mega]');
      var chips = root.querySelector('[data-khc-chips]');
      if (megaBtn && mega) {
        megaBtn.addEventListener('click', function () {
          var open = mega.hasAttribute('hidden');
          if (open) {
            mega.removeAttribute('hidden');
          } else {
            mega.setAttribute('hidden', '');
          }
          megaBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (chips) chips.style.opacity = open ? '.4' : '1';
        });
      }

      // Fades laterales de las pills mobile (scroll horizontal)
      var pillsWrap = root.querySelector('[data-khc-pills]');
      var pillsRow = pillsWrap && pillsWrap.querySelector('.khc-mob__pills');
      if (pillsWrap && pillsRow) {
        var updatePills = function () {
          var max = pillsRow.scrollWidth - pillsRow.clientWidth;
          pillsWrap.classList.toggle('is-scrolled', pillsRow.scrollLeft > 4);
          pillsWrap.classList.toggle('is-end', pillsRow.scrollLeft >= max - 4);
        };
        pillsRow.addEventListener('scroll', updatePills, { passive: true });
        window.addEventListener('resize', updatePills);
        updatePills();
        pillsRow.addEventListener('click', function (e) {
          var pill = e.target.closest('[data-khc-pill-index]');
          if (!pill) return;
          trackEvent('nav_pill_click', {
            position: Number(pill.getAttribute('data-khc-pill-index')) || null,
            label: pill.getAttribute('data-khc-pill-label') || '',
          });
        });
      }

      // Line switching (desktop custom)
      root.querySelectorAll('[data-khc-line]').forEach(function (btn) {
        var activate = function () {
          var idx = btn.getAttribute('data-khc-line');
          root.querySelectorAll('[data-khc-line]').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
          root.querySelectorAll('[data-khc-panel]').forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-khc-panel') === idx);
          });
        };
        btn.addEventListener('mouseenter', activate);
        btn.addEventListener('click', activate);
      });

      // Menú mobile: abre el scaffold .sf-menu-wrapper (que Buddha rellena).
      // Idempotente con el Megamenu del tema si también engancha .sf-menu-button.
      var wrapper = root.querySelector('[data-khc-menu-wrapper]');
      if (wrapper) {
        var content = wrapper.querySelector('.sf-menu-content');
        var DUR = 300;
        var openMenu = function () {
          wrapper.classList.remove('hidden');
          document.documentElement.classList.add('prevent-scroll');
          setTimeout(function () {
            wrapper.style.setProperty('--tw-bg-opacity', '0.3');
            if (wrapper.firstElementChild) wrapper.firstElementChild.classList.remove('-translate-x-full');
          });
        };
        var closeMenu = function () {
          wrapper.style.setProperty('--tw-bg-opacity', '0');
          if (wrapper.firstElementChild) wrapper.firstElementChild.classList.add('-translate-x-full');
          setTimeout(function () {
            wrapper.classList.add('hidden');
            document.documentElement.classList.remove('prevent-scroll');
            if (content) content.classList.remove('sf-sub-menu-open', 'open-level-1', 'open-level-2');
          }, DUR);
        };
        root.querySelectorAll('.sf-menu-button').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            openMenu();
          });
        });
        wrapper.addEventListener('click', function (e) {
          if (e.target === wrapper) closeMenu();
        });
        wrapper.addEventListener('click', function (e) {
          var back = e.target.closest('.back');
          if (back) {
            e.preventDefault();
            var lvl = back.getAttribute('data-level');
            var subB = back.closest('.sf-sub-links');
            if (content && lvl === '1') content.classList.remove('sf-sub-menu-open');
            if (content) content.classList.remove('open-level-' + lvl);
            setTimeout(function () {
              if (subB) subB.classList.add('hidden');
            }, DUR);
            return;
          }
          var toggle = e.target.closest('[data-toggle-submenu]');
          if (toggle && wrapper.contains(toggle)) {
            e.preventDefault();
            var level = toggle.getAttribute('data-toggle-submenu');
            var link = toggle.closest('.sf-link');
            var sub = link ? link.querySelector('.sf-sub-links') : null;
            if (!sub) return;
            sub.classList.add('flex');
            sub.classList.remove('hidden');
            if (content) content.classList.add('open-level-' + level);
            setTimeout(function () {
              if (content) content.classList.add('sf-sub-menu-open');
            }, DUR);
          }
        });
      }

      // Panel de búsqueda: vacío (recientes/tendencias/favoritos) · resultados · sin resultados
      // Aplica a todas las instancias (desktop y mobile).
      root.querySelectorAll('[data-khc-search]').forEach(function (search) {
        var input = search.querySelector('[data-khc-search-input]');
        var panel = search.querySelector('[data-khc-search-panel]');
        var form = search.querySelector('form');
        var emptyEl = search.querySelector('[data-khc-empty]');
        var resultsState = search.querySelector('[data-khc-results-state]');
        var noResults = search.querySelector('[data-khc-noresults]');
        var suggWrap = search.querySelector('[data-khc-suggestions-wrap]');
        var suggEl = search.querySelector('[data-khc-suggestions]');
        var resultsEl = search.querySelector('[data-khc-results]');
        var allLink = search.querySelector('[data-khc-results-all]');
        var nrTerm = search.querySelector('[data-khc-nr-term]');
        var recentsWrap = search.querySelector('[data-khc-recents-wrap]');
        var recentsEl = search.querySelector('[data-khc-recents]');
        var base = root.getAttribute('data-predictive-url') || '/search/suggest';
        var searchUrl = base.replace('/suggest', '');
        var RECENT_KEY = 'khc-recent-searches';
        var timer = null;

        var esc = function (str) {
          return String(str == null ? '' : str).replace(/[&<>"]/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
          });
        };
        var getRecents = function () {
          try {
            return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
          } catch (e) {
            return [];
          }
        };
        var saveRecent = function (q) {
          q = (q || '').trim();
          if (!q) return;
          var r = getRecents().filter(function (x) {
            return x.toLowerCase() !== q.toLowerCase();
          });
          r.unshift(q);
          r = r.slice(0, 4);
          try {
            localStorage.setItem(RECENT_KEY, JSON.stringify(r));
          } catch (e) {}
        };
        var showState = function (name) {
          if (emptyEl) emptyEl.hidden = name !== 'empty';
          if (resultsState) resultsState.hidden = name !== 'results';
          if (noResults) noResults.hidden = name !== 'noresults';
        };
        var renderRecents = function () {
          if (!recentsWrap || !recentsEl) return;
          var r = getRecents();
          if (!r.length) {
            recentsWrap.hidden = true;
            return;
          }
          recentsWrap.hidden = false;
          recentsEl.innerHTML = r
            .map(function (x) {
              return (
                '<button type="button" class="khc-sp__recent" data-khc-fill="' +
                esc(x) +
                '">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A9ADBB" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg>' +
                '<span>' +
                esc(x) +
                '</span></button>'
              );
            })
            .join('');
        };
        var openPanel = function () {
          if (panel) panel.removeAttribute('hidden');
          search.classList.add('is-open');
        };
        var closePanel = function () {
          if (panel) panel.setAttribute('hidden', '');
          search.classList.remove('is-open');
        };
        var openEmpty = function () {
          renderRecents();
          showState('empty');
          openPanel();
        };

        var runQuery = function (q) {
          q = (q || '').trim();
          if (allLink) allLink.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product';
          if (q.length < 2) {
            openEmpty();
            return;
          }
          var url =
            base +
            '.json?q=' +
            encodeURIComponent(q) +
            '&resources[type]=product,query&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=title,vendor,product_type,variants.title,tag,body';
          fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (r) {
              return r.json();
            })
            .then(function (data) {
              var res = (data.resources && data.resources.results) || {};
              var products = res.products || [];
              var queries = res.queries || [];
              if (!products.length) {
                if (nrTerm) nrTerm.textContent = q;
                showState('noresults');
                openPanel();
                trackEvent('site_search_no_results', { search_term: q });
                return;
              }
              trackEvent('site_search', { search_term: q, results_count: products.length });
              if (suggEl && suggWrap) {
                var qs = queries.slice(0, 4);
                suggWrap.hidden = qs.length === 0;
                suggEl.innerHTML = qs
                  .map(function (qq, idx) {
                    return (
                      '<button type="button" class="khc-sp__sugg" data-khc-fill="' +
                      esc(qq.text) +
                      '" data-khc-index="' +
                      (idx + 1) +
                      '">' +
                      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#A9ADBB" stroke-width="2.4" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg>' +
                      '<span>' +
                      (qq.styled_text || esc(qq.text)) +
                      '</span></button>'
                    );
                  })
                  .join('');
              }
              if (resultsEl) {
                var maxResults = 4;
                resultsEl.innerHTML = products
                  .slice(0, maxResults)
                  .map(function (p, idx) {
                    var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image || '';
                    var off = '';
                    var cap = parseFloat(p.compare_at_price_max || p.compare_at_price || 0);
                    var pr = parseFloat(p.price_max || p.price || 0);
                    var onSale = !!(cap && pr && cap > pr);
                    if (onSale) {
                      off = '<span class="khc-sp__off">-' + Math.round(((cap - pr) / cap) * 100) + '%</span>';
                    }
                    var priceHtml =
                      '<div class="khc-sp__card-price">' +
                      '<span class="khc-sp__now">' + formatMoney(Math.round(pr * 100), MinimogSettings.money_format) + '</span>' +
                      (onSale ? '<span class="khc-sp__was">' + formatMoney(Math.round(cap * 100), MinimogSettings.money_format) + '</span>' : '') +
                      '</div>';
                    return (
                      '<a class="khc-sp__card" href="' +
                      p.url +
                      '" data-khc-index="' +
                      (idx + 1) +
                      '">' +
                      '<div class="khc-sp__card-media">' +
                      (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
                      off +
                      '</div>' +
                      '<div class="khc-sp__card-name">' +
                      esc(p.title) +
                      '</div>' +
                      priceHtml +
                      '</a>'
                    );
                  })
                  .join('');
              }
              showState('results');
              openPanel();
            })
            .catch(function () {});
        };

        if (input) {
          input.addEventListener('focus', function () {
            if (input.value.trim().length < 2) {
              openEmpty();
            } else {
              runQuery(input.value);
            }
          });
          input.addEventListener('input', function () {
            clearTimeout(timer);
            var q = input.value;
            timer = setTimeout(function () {
              runQuery(q);
            }, 220);
          });
        }
        if (panel) {
          panel.addEventListener('click', function (e) {
            var card = e.target.closest('.khc-sp__card');
            if (card) {
              var nameEl = card.querySelector('.khc-sp__card-name');
              trackEvent(resultsState && !resultsState.hidden ? 'search_result_click' : 'favorite_component_click', {
                search_term: input ? input.value.trim() : '',
                item_name: nameEl ? nameEl.textContent.trim() : '',
                position: Number(card.getAttribute('data-khc-index')) || null,
              });
            }
            var f = e.target.closest('[data-khc-fill]');
            if (!f) return;
            var evtType = f.classList.contains('khc-sp__trend')
              ? 'trending_cyber_click'
              : f.classList.contains('khc-sp__recent')
              ? 'search_recent_click'
              : f.classList.contains('khc-sp__sugg')
              ? 'search_suggestion_click'
              : null;
            if (evtType) {
              trackEvent(evtType, {
                search_term: f.getAttribute('data-khc-fill'),
                position: Number(f.getAttribute('data-khc-index')) || null,
              });
            }
            var v = f.getAttribute('data-khc-fill');
            if (input) {
              input.value = v;
              input.focus();
            }
            if (evtType === 'search_suggestion_click' || evtType === 'trending_cyber_click' ||  evtType === 'search_recent_click') {
              saveRecent(v);
              window.location.href = searchUrl + '?q=' + encodeURIComponent(v) + '&type=product';
              return;
            }
            runQuery(v);
          });
        }
        if (form) {
          form.addEventListener('submit', function () {
            saveRecent(input && input.value);
          });
        }
        document.addEventListener('click', function (e) {
          if (!search.contains(e.target)) closePanel();
        });
      });
    }
    function boot() {
      document.querySelectorAll('[data-khc-root]').forEach(initRoot);
    }
    if (document.readyState !== 'loading') boot();
    else document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
